import requests from "../agent";

const Destino = {
  getAll: () => requests.get("/Destino/getAll"),
  getAllByFilter: (data) => requests.post("Destino/GetAllByFilter", data),
  activeOrInactive: (data) =>
    requests.put("Proveedores/ActivarDesactivarProveedor", data),
  create: (data) => requests.post("Destino/Create", data),
  update: (data) => requests.put("Destino/Update", data),
  delete: (id) => requests.delete(`Destino/Delete/${id}`),
  activeOrInActive: (id) => requests.put(`Destino/ActiveOrInActive/${id}`),
};

export default Destino;
